import React, { useEffect, useContext } from 'react';
import { getDoc, doc, getFirestore } from 'firebase/firestore';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import MusicHome from './MusicHome';
import Marketplace from './Marketplace';
import NFTDetail from './NFTDetail';

const Music = ({ onProfilePress, onPlayVideo, isVideoPlaying, onMoveMP }) => {
  const { assetsSummary, setAssetsSummary } = useContext(AppContext);



  return (
    <Routes>
      {/* when URL is /music exactly */}
      <Route
        index
        element={
          <MusicHome
            assets={assetsSummary}
            onPlayVideo={onPlayVideo}
            isVideoPlaying={isVideoPlaying}
          />
        }
      />

      <Route
        path="marketplace"
        element={
          <Marketplace
            assets={assetsSummary}
            onPlayVideo={onPlayVideo}
            isVideoPlaying={isVideoPlaying}
          />
        }
      />

      <Route
        path="nft/:id"
        element={
          <NFTDetail
            onProfilePress={onProfilePress}
            onMoveMP={onMoveMP}
          />
        }
      />

      {/* Any unknown sub-path under /music/* goes back to the home of this section */}
      <Route
        path="*"
        element={<Navigate to="" replace />}
      />
    </Routes>
  );
};

export default Music;
